<template>
  <div class="right_col" role="main">
    <div class>
      <div class="page-title">
        <div class="title_left">
          <h3>{{ $t('subMenu.allShopsConfig') }}</h3>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="x_panel">
            <div class="x_content form-horizontal">
              <alert
                :title="$t('subMenu.allShopsConfig')"
                :success-message="$t('common.isSuccess')"
                :error-message="$t('common.isFailure')"
                :alerts="alerts"
                :errors="errors"
                :display="alertDisplay"
                @closeAlert="closeAlert"
              />
              <p class="text-danger text-center strong">
                <strong>
                  {{
                    $t('operationalManagementPage.soOrderLimitCountAttention')
                  }}
                </strong>
              </p>
              <div class="form-group">
                <label class="control-label col-md-2 col-sm-2 col-xs-12"
                  >{{ $t('operationalManagementPage.orderLimit') }}：</label
                >
                <label
                  class="control-label col-md-1 col-sm-2 col-xs-12"
                  for="shop"
                  >{{ $t('operationalManagementPage.shop') }}：</label
                >
                <div class="col-md-5 col-sm-5 col-xs-12">
                  <input
                    id="shop"
                    v-model="shopOrderLimit"
                    v-validate="ValidRules.shop"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('operationalManagementPage.orderLimitShop')"
                    :placeholder="$t('operationalManagementPage.itemMinMax')"
                    type="number"
                    name="shop"
                    min="0"
                    max="99"
                    class="form-control"
                  />
                  <div
                    v-show="validator.has('shop')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('shop')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="table"
                  >{{ $t('operationalManagementPage.table') }}：</label
                >
                <div class="col-md-5 col-sm-5 col-xs-12">
                  <input
                    id="table"
                    v-model="seatOrderLimit"
                    v-validate="ValidRules.table"
                    :disabled="isConfirmView"
                    :data-vv-as="
                      $t('operationalManagementPage.orderLimitTable')
                    "
                    :placeholder="$t('operationalManagementPage.itemMinMax')"
                    type="number"
                    name="table"
                    min="0"
                    max="99"
                    class="form-control"
                  />
                  <div
                    v-show="validator.has('table')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('table')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="pre"
                  >{{ $t('operationalManagementPage.preOrder') }}：</label
                >
                <div class="col-md-5 col-sm-5 col-xs-12">
                  <input
                    id="pre"
                    v-model="preOrderLimit"
                    v-validate="ValidRules.pre"
                    :disabled="isConfirmView"
                    :data-vv-as="
                      $t('operationalManagementPage.orderLimitPreOrder')
                    "
                    :placeholder="$t('operationalManagementPage.itemMinMax')"
                    type="number"
                    name="pre"
                    min="0"
                    max="99"
                    class="form-control"
                  />
                  <div
                    v-show="validator.has('pre')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('pre')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <p class="text-center text-muted">
                <strong>
                  {{ $t('operationalManagementPage.soOperationAttention') }}
                </strong>
              </p>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="smartOrder"
                >
                  {{ $t('operationalManagementPage.soOperation') }}：
                  <span class="required">*</span>
                </label>
                <div
                  id="smartOrder"
                  class="col-md-5 col-sm-5 col-xs-12 text-danger select-radio"
                >
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="smartOrderT"
                      v-model="smartOrder"
                      v-validate="ValidRules.smartOrder"
                      :disabled="isConfirmView"
                      :data-vv-as="$t('operationalManagementPage.soOperation')"
                      type="radio"
                      class="flat"
                      name="smartOrder"
                      value="1"
                    />
                    <label class="control-label" for="smartOrderT">{{
                      $t('common.operation')
                    }}</label>
                  </div>
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="smartOrderF"
                      v-model="smartOrder"
                      :disabled="isConfirmView"
                      type="radio"
                      class="flat"
                      name="smartOrder"
                      value="0"
                    />
                    <label class="control-label" for="smartOrderF">{{
                      $t('common.stop')
                    }}</label>
                  </div>
                  <div
                    v-show="validator.has('smartOrder')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'smartOrder'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="bikkuraponRateChange"
                >
                  {{ $t('operationalManagementPage.bikkuraponRateChange') }}：
                  <span class="required">*</span>
                </label>
                <div
                  id="bikkuraponRateChange"
                  class="col-md-5 col-sm-5 col-xs-12 text-danger select-radio"
                >
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="bikkuraponRateChangeT"
                      v-model="bikkuraponRateChangeEnabled"
                      v-validate="ValidRules.bikkuraponRateChange"
                      :disabled="isConfirmView"
                      :data-vv-as="
                        $t('operationalManagementPage.bikkuraponRateChange')
                      "
                      type="radio"
                      class="flat"
                      name="bikkuraponRateChange"
                      value="1"
                    />
                    <label class="control-label" for="bikkuraponRateChangeT">{{
                      $t('common.operation')
                    }}</label>
                  </div>
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="bikkuraponRateChangeF"
                      v-model="bikkuraponRateChangeEnabled"
                      :disabled="isConfirmView"
                      type="radio"
                      class="flat"
                      name="bikkuraponRateChange"
                      value="0"
                    />
                    <label class="control-label" for="bikkuraponRateChangeF">{{
                      $t('common.stop')
                    }}</label>
                  </div>
                  <div
                    v-show="validator.has('bikkuraponRateChange')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'bikkuraponRateChange'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="priceDisplay"
                >
                  {{ $t('operationalManagementPage.priceDisplay') }}：
                  <span class="required">*</span>
                </label>
                <div
                  id="priceDisplay"
                  class="col-md-5 col-sm-5 col-xs-12 text-danger select-radio"
                >
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="priceDisplayT"
                      v-model="priceDisplayEnabled"
                      v-validate="ValidRules.priceDisplay"
                      :disabled="isConfirmView"
                      :data-vv-as="$t('operationalManagementPage.priceDisplay')"
                      type="radio"
                      class="flat"
                      name="priceDisplay"
                      value="1"
                    />
                    <label class="control-label" for="priceDisplayT">{{
                      $t('common.display')
                    }}</label>
                  </div>
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="priceDisplayF"
                      v-model="priceDisplayEnabled"
                      :disabled="isConfirmView"
                      type="radio"
                      class="flat"
                      name="priceDisplay"
                      value="0"
                    />
                    <label class="control-label" for="priceDisplayF">{{
                      $t('common.hidden')
                    }}</label>
                  </div>
                  <div
                    v-show="validator.has('priceDisplay')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'priceDisplay'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="bikkuraponIconDisplay"
                >
                  {{ $t('operationalManagementPage.bikkuraponIconDisplay') }}：
                  <span class="required">*</span>
                </label>
                <div
                  id="bikkuraponIconDisplay"
                  class="col-md-5 col-sm-5 col-xs-12 text-danger select-radio"
                >
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="bikkuraponIconDisplayT"
                      v-model="bikkuraponIconDisplayEnabled"
                      v-validate="ValidRules.bikkuraponIconDisplay"
                      :disabled="isConfirmView"
                      :data-vv-as="
                        $t('operationalManagementPage.bikkuraponIconDisplay')
                      "
                      type="radio"
                      class="flat"
                      name="bikkuraponIconDisplay"
                      value="1"
                    />
                    <label class="control-label" for="bikkuraponIconDisplayT">{{
                      $t('common.display')
                    }}</label>
                  </div>
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="bikkuraponIconDisplayF"
                      v-model="bikkuraponIconDisplayEnabled"
                      :disabled="isConfirmView"
                      type="radio"
                      class="flat"
                      name="bikkuraponIconDisplay"
                      value="0"
                    />
                    <label class="control-label" for="bikkuraponIconDisplayF">{{
                      $t('common.hidden')
                    }}</label>
                  </div>
                  <div
                    v-show="validator.has('bikkuraponIconDisplay')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'bikkuraponIconDisplay'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="ln_solid"></div>
              <div class="form-group">
                <div
                  v-if="isConfirmView"
                  class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3"
                >
                  <button @click="back" class="btn btn-default">
                    {{ $t('common.back') }}
                  </button>
                  <button @click="submit" class="btn btn-success">
                    {{ $t('orderPage.registration') }}
                  </button>
                </div>
                <div v-else class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3">
                  <button @click="confirm" class="btn btn-success">
                    {{ $t('common.inputComplete') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Alert from '@/components/common/alert/Alert'
import GlobalRequest from '@/http/GlobalRequest'
import ValidRules from '@/validator/ShopSettingAllRules'
import { mapGetters } from 'vuex'
import alert from '@/mixin/alert'
export default {
  components: {
    Alert,
  },
  mixins: [alert],
  data() {
    return {
      shopOrderLimit: '',
      seatOrderLimit: '',
      preOrderLimit: '',
      smartOrder: 0,
      priceDisplayEnabled: 0,
      bikkuraponRateChangeEnabled: 0,
      bikkuraponIconDisplayEnabled: 0,
      isConfirmView: false,
      ValidRules: ValidRules,
    }
  },
  computed: {
    ...mapGetters({
      fetchedData: 'global/getSettings',
      language: 'settings/getLanguage',
    }),
  },
  watch: {
    fetchedData: function(newValue) {
      this.smartOrder = newValue.smartOrder || 0
      this.priceDisplayEnabled = newValue.priceDisplayEnabled || 0
      this.bikkuraponRateChangeEnabled =
        newValue.bikkuraponRateChangeEnabled || 0
      this.bikkuraponIconDisplayEnabled =
        newValue.bikkuraponIconDisplayEnabled || 0
    },
    language() {
      this.$store.dispatch('global/getSettings')
    },
  },
  mounted() {
    this.$store.dispatch('global/getSettings')
  },
  methods: {
    confirm: function() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.isConfirmView = true
        }
      })
    },
    back: function() {
      this.isConfirmView = false
    },
    submit: function() {
      const request = new GlobalRequest()
      const params = {
        smartOrder: this.smartOrder,
        priceDisplayEnabled: this.priceDisplayEnabled,
        bikkuraponRateChangeEnabled: this.bikkuraponRateChangeEnabled,
        bikkuraponIconDisplayEnabled: this.bikkuraponIconDisplayEnabled,
      }
      if (this.shopOrderLimit !== '') {
        params.shopOrderLimit = Number(this.shopOrderLimit)
      }
      if (this.seatOrderLimit !== '') {
        params.seatOrderLimit = Number(this.seatOrderLimit)
      }
      if (this.preOrderLimit !== '') {
        params.preOrderLimit = Number(this.preOrderLimit)
      }
      request
        .update(params)
        .then(() => {
          this.openSuccessAlert()
        })
        .catch((err) => {
          this.openErrorAlert(err.response.data)
          console.log(err)
        })
        .finally(() => {
          this.isConfirmView = false
        })
    },
  },
}
</script>
<style scoped>
div.select-radio label {
  margin-left: 3px;
}

div.select-radio div {
  padding-left: 0;
}
p.text-center strong {
  white-space: pre-wrap;
}
</style>
